@if (total && isLoading) {
	<div class="counter-wrapper">
		<div class="ongoing-counter" [class.has-loading-error]="failed">
			{{ uploaded }} / {{ total }}
		</div>
		@if (isLoading) {
			<div class="counter-spinner-wrapper">
				<mat-spinner diameter="20" />
			</div>
		}
	</div>
}

@if (total && !isLoading) {
	<div class="counter-wrapper">
		<div class="total-counter">
			{{ total }}
		</div>
		@if (timeForSuccessTick()) {
			<mat-icon svgIcon="checked_good" />
		}
	</div>
}
